module.exports = __webpack_public_path__ + "assets/img/order_5.f6f19bb8.svg";